// modules
import { createAction } from 'redux-actions'

export const setQuickMessagesManagementList = createAction(
  'SET_QUICK_MESSAGES_MANAGEMENT_LIST'
)
export const setQuickMessagesManagementEditItem = createAction(
  'SET_QUICK_MESSAGES_MANAGEMENT_EDIT_ITEM'
)

export const resetQuickMessagesManagement = createAction(
  'RESET_QUICK_MESSAGES_MANAGEMENT'
)
